import { Stack, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { uniqueId } from "lodash";
import React from "react";
import { AiOutlinePoweroff } from "react-icons/ai";
import { PiPackage } from "react-icons/pi";

const MenuHover = ({
  anchorEl,
  open,
  handleClose,
  handleOnClickYourOrders,
  handleLogout,
}) => {
  return (
    <Menu
      id="account-menu"
      aria-labelledby="account-menu"
      data-testid="account-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <MenuItem key={uniqueId()} onClick={handleOnClickYourOrders}>
        <Stack
          direction="row"
          alignItems="center"
          gap="0.8rem"
          justifyContent="center"
        >
          <PiPackage />
          <Typography>Your orders</Typography>
        </Stack>
      </MenuItem>
      <MenuItem key={uniqueId()} onClick={handleLogout}>
        <Stack
          direction="row"
          alignItems="center"
          gap="0.8rem"
          justifyContent="center"
        >
          <AiOutlinePoweroff />
          <Typography>Log out</Typography>
        </Stack>
      </MenuItem>
    </Menu>
  );
};

export default MenuHover;
